export class MaintenanceRunStatusFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<MaintenanceRunStatus>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<MaintenanceRunStatus>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MaintenanceRunStatusFilters.attributeTypeMap;
    }
    constructor() {
    }
}
